import { api } from '@cma/app'
import { AccountOption } from '@cma/common'
import {
  AccountOptionsQuery,
  AccountOptionsQueryVariables
} from '@cma/generated/graphql'
import { UseMutationOptions, useMutation } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useAccountOptions(
  options?: Omit<
    UseMutationOptions<AccountOption[], Error, string>,
    'mutationFn'
  >
) {
  return useMutation<AccountOption[], Error, string>(async (email) => {
    const query = gql`
      query AccountOptions($email: String!) {
        accountOptions(email: $email) {
          accountId
          name
          accountType
          role
          totalReports
          lastReportCreatedAt
          accountLogo
          userLogo
          platformSignInRequired
        }
      }
    `
    const res = await api<AccountOptionsQuery, AccountOptionsQueryVariables>({
      query,
      variables: { email }
    })

    return res.accountOptions
  }, options)
}
